import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EarlyExitDetails} from "../../model/EarlyExitDetails";
import {QuotationService} from "../../services/quotation-service/quotation.service";
import {WebLeadType} from "../../model/leads/WebLeadType";
import {ErrorCodes} from "../../model/ErrorCodes";
import {QuotationRequest} from "../../model/QuotationRequest";
import {LeadService} from "../../services/lead-service/lead.service";
import {CampaignTrackingService} from "../../services/campaign-tracking/campaign-tracking.service";
import {GoogleAnalyticsService} from "google-analytics";

declare let jQuery: any;
declare let jcf:any

@Component({
  selector: 'app-early-exit',
  templateUrl: './early-exit.component.html',
  styleUrls: ['./early-exit.component.scss']
})
export class EarlyExitComponent implements OnInit {
  public showContactInput: boolean = false;
  public earlyExitInfo: EarlyExitDetails = new EarlyExitDetails();
  public earlyExitReasons: any;
  public showFeedback: boolean = false;
  private _name: string = '';
  private _phoneNumber: string = '';
  private _uniqueId: string = 'DISCOEXIT';
  private _productType = 'Car and home insurance';
  private _campaign = 'None';
  private _medium = 'Early exit web leads survey';
  private _comment = 'Reason for early exit: ';

  constructor(private quotationService: QuotationService,
              private leadService: LeadService,
              private campaignTrackingService: CampaignTrackingService,
              private googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit() {
    this.earlyExitInfo.contactMe = 'No';
    this._getEarlyExitReasons();
  }

  public contactMe(option: string): void {
    this.earlyExitInfo.contactMe = option;
    this.showContactInput = option === 'Yes' ? true : false;
  }

  public onSelectChanged(value: string): void {
    this.earlyExitInfo.exitReason = value;
  }

  public submit(): void {
    if (this.isEarlyExistReasonValid()) {
      this.submitCampaignTrackerInfo();
    } else if (this.isQuoteDetailsValid()) {
      this.logEarlyExitNinjaLead();
    }
    this.showFeedback = true;
  }

  public canSubmit(): boolean {
    return this.isEarlyExistReasonValid() || this.isQuoteDetailsValid();
  }

  public _buildFormData(): FormData {
    let formData: FormData = new FormData();

    formData.append("uniqueId", this._uniqueId);
    formData.append("results", this.earlyExitInfo.exitReason);
    formData.append("results", this.earlyExitInfo.contactMe);
    formData.append("results", this._name);
    formData.append("results",this._phoneNumber);
    formData.append("results", this._productType);

    return formData;
  }

  public isEarlyExistReasonValid(): boolean {
    return !!this.earlyExitInfo && (!!this.earlyExitInfo.exitReason && this.earlyExitInfo.exitReason !== '') &&
      (!!this.earlyExitInfo.contactMe && this.earlyExitInfo.contactMe === 'No');
  }

  public isQuoteDetailsValid(): boolean {
    return !!this.earlyExitInfo && !!this.earlyExitInfo.name && this.earlyExitInfo.name !== ''
      && !!this.earlyExitInfo.number && this.earlyExitInfo.number !== '';
  }

  public submitCampaignTrackerInfo(): void {
    this.campaignTrackingService.submitCapturedData(this._buildFormData()).subscribe();
  }

  public logEarlyExitNinjaLead(): void {
    this._mapQuotationRequest();
    this.leadService.registerEarlyExitLead(WebLeadType.EARLY_EXIT_WEB_SURVEY).subscribe(
      response => {
        if (response.status === ErrorCodes['USER_HAS_PRODUCT']) {
          this.leadService.doesUserHaveProduct = true;
        } else {
          this.leadService.doesUserHaveProduct = false;
          this.leadService.createLeadResponse = response.body;
          if(response.body['leadReferenceNumber']){
            this.googleAnalyticsService.postGaEvent(
              'generate_ninja_lead',
              {
                'form_name': 'insure_early_exit',
                'form_action': 'early_exit',
                'form_step': 1,
                'lead_id': response.body['leadReferenceNumber']
              }
            );
          }
        }
      },
      error1 => {
        if (error1['error'].toLowerCase().indexOf('active')) {
          this.leadService.doesUserHaveProduct = true;
        }
    });
    this.quotationService.quotationRequest = new QuotationRequest();
  }

  public navigateHome(): void {
      window.parent.location.href = '/portal';
  }

  private _getEarlyExitReasons() {
    this.quotationService.getEarlyExitReasons().subscribe(response => {
      if (response) {
        this.earlyExitReasons = response;
        jQuery(function () {
          // @ts-ignore
          jcf.replaceAll();
        });
      }
    });
  }

  private _mapQuotationRequest(): void {
    this.quotationService.quotationRequest.name = this.earlyExitInfo.name;
    this.quotationService.quotationRequest.cellphone = this.earlyExitInfo.number;
    this.quotationService.quotationRequest.campaign = this._campaign;
    this.quotationService.quotationRequest.medium = this._medium;
    this.quotationService.quotationRequest.comment = this._comment + this.earlyExitInfo.exitReason;
  }
}
